import React, { useState } from 'react';
import store from '@apply/adminStore';
import ActionSheet from 'devextreme-react/action-sheet';
import { executeBrokerAction, getBrokerActions } from '../Functions';
import { BrokerActionType } from '../Constants';
import { LoadPanel } from 'devextreme-react/load-panel';
import { RefreshEvents } from '../../../common/SharedEvents';
import { handleAdminInfo, handleAdminSuccess, handleAdminError } from '../../../common/SharedFunctions';

export const BrokerActionsButton = ({ data, parentId }) => {
    const { user } = store.getState();

    const refreshEvents = new RefreshEvents();

    const [loadPanelOpen, set_loadPanelOpen] = useState(false);
    const [actionData, set_actionData] = useState({
        visible: false,
        target: null,
        items: [],
    });

    const onActionClicked = (event, rowItem) => {
        event.preventDefault();
        event.stopPropagation();

        const actions = getBrokerActions(rowItem, user);

        if (actions.length === 0) {
            handleAdminInfo('No actions available');
            return;
        }

        var data = {
            items: actions,
            target: `#${event.target.id}`,
            visible: true,
        };
        set_actionData(data);
    };

    const onActionItemClick = async (e) => {
        try {
            if (e.itemData.actionId === BrokerActionType.SendPasswordResetEmail) {
                set_loadPanelOpen(true);
            }

            set_actionData({ ...actionData, visible: false });
            const isOk = await executeBrokerAction(e.itemData);

            if (e.itemData.actionId === BrokerActionType.SendPasswordResetEmail) {
                if (isOk) {
                    handleAdminSuccess('A password reset email has been sent to the selected broker');
                    refreshEvents.dispatchRefreshEvent();
                } else {
                    handleAdminError(
                        new Error('Failed to reset password'),
                        'An unexpected error occurred while performing your task. Please try again.'
                    );
                }
            }
        } finally {
            set_loadPanelOpen(false);
        }
    };

    const onActionSheetVisibleChange = (isVisible) => {
        if (isVisible !== actionData?.visible) {
            set_actionData({ ...actionData, visible: isVisible });
        }
    };

    const isVisible = (rowItem) => {
        const actions = getBrokerActions(rowItem, user);
        return actions.length > 0;
    };

    if (!data) {
        return null;
    }

    if (!data || !isVisible(data)) {
        return null;
    }

    return (
        <>
            <button
                id={`${parentId}_action_${data.id ?? 0}`}
                className='gridButton'
                title='Click to see options'
                onClick={(event) => onActionClicked(event, data)}
            >
                ...
            </button>
            <ActionSheet
                title='Choose action'
                usePopover={true}
                visible={actionData.visible}
                target={actionData.target}
                items={actionData.items}
                onItemClick={onActionItemClick}
                onVisibleChange={onActionSheetVisibleChange}
                showTitle={false}
            />
            <LoadPanel
                hideOnOutsideClick={false}
                visible={loadPanelOpen}
                message='Please wait...'
            />
        </>
    );
};
